import React, { useEffect } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';

import { useRouter } from '../helpers/hooks';
import { matchRoute } from '../helpers/business';

export const stages = {
  payMethodSelector: 0,
  payWaySelector: 1,
  payment: 2,
  invoiceResult: 3,
};

export default function ConnectedProgress() {
  const {
    location: { pathname },
  } = useRouter();

  const {
    t,
    i18n: { language },
  } = useTranslation();

  const currentRoute = matchRoute(pathname);

  let stage;

  if (currentRoute && stages.hasOwnProperty(currentRoute)) {
    stage = stages[currentRoute];
  } else {
    stage = 0;
  }

  useEffect(() => {
    const projectName = process.env.REACT_APP_PROJECT_NAME;

    switch (stage) {
      case 0:
        document.title = projectName + '-' + t('Progress.Method');
        break;
      case 1:
        document.title = projectName + '-' + t('Progress.Requisites');
        break;
      case 2:
        document.title = projectName + '-' + t('Progress.Payment');
        break;
      default:
        document.title = projectName + '-' + t('Progress.Method');
    }
  }, [language, stage]);

  return <Progress stage={stage} />;
}

export function Progress({ stage }) {
  // STEPS START
  //   stage 1 - default style
  //   stage 2 - add class steps--stage2 to steps
  //   stage 3 - add class steps--stage3 to steps
  //   complete stage - add steps--complete and steps--stage3
  //   rejected stage - add steps--rejected and steps--stage3

  const { t } = useTranslation();

  return (
    <div
      className={classnames(
        'steps',
        { 'steps--stage2': stage === 1 },
        { 'steps--stage3': stage === 2 || stage === 3 },
        { 'steps--stage3 steps--complete': stage === 3 }
      )}
    >
      <div className="steps__stage1">
        <span>{t('Progress.Method')}</span>
      </div>
      <div className="steps__stage2">
        <span>{t('Progress.Requisites')}</span>
      </div>
      <div className="steps__stage3">
        <span>{t('Progress.Payment')}</span>
      </div>
    </div>
  );
}
